export default "<div class=\"widget\">\n    <app-assignee-home [assignee]=\"appData.loggedInAssignee\"></app-assignee-home>\n</div>\n"